/**
 * 多版本菜单批 L2（后端仓 plan `docs/plans/2026-10-28-multi-menu-link-only-multi-table-plan.md` §2.4，调研 D9 = A）：
 * 「顾客不能改桌号」（门店 / 集团设置 `disableTableSelect`，get-venue `settings.venueGroup.disableTableSelect`）只锁**扫码带来的桌号**。
 *
 * 进店时没有桌号（通用桌码、Any table / Some tables 链接，地址是 `/t/n-t`）⇒ 下拉照样能选。
 * 改之前锁 = 开关本身：「锁 + /t/n-t + 门店有桌号表」时下拉与展示框都禁用、桌号又必填 ⇒ 顾客卡在购物车（调研 C4）。
 *
 * review 第 1 轮（gstack P3）：通用桌码进来（地址进店参数 `mmEntry=gtable`，`qrEntry.js` `entryOfQuery` 的 generalTable）后顾客在首页
 * 自己填了桌号，购物车路由是 `/cart/t/<桌>` —— 那也不是扫码带来的桌号，不锁。地址上没有进店参数（老标签页 / 没走进店守卫）⇒ 照旧按路由桌号判。
 */
import { NO_INPUT_TABLE_NUMBER } from '@/utils/constants'
import { entryOfQuery } from '@/utils/menu/qrEntry'

/** 进店地址上带没带扫码桌号（`/t/:number`）：非空、不是「无桌号入口」占位符 `n-t` */
export function hasScannedTable(number) {
  if (typeof number === 'number') return isFinite(number)
  if (typeof number !== 'string') return false
  return number.trim() !== '' && number !== NO_INPUT_TABLE_NUMBER
}

/**
 * 购物车桌号下拉锁不锁：开关为真（真假口径与改之前相同）且 进店带了扫码桌号 且 不是通用桌码进来的。
 * @param {*} lockSetting `venueGroupSettings.disableTableSelect`
 * @param {String|Number} number 购物车路由上的桌号
 * @param {Object} [query] 购物车路由的 query（`this.$route.query`）；看进店参数 `mmEntry`
 */
export function isTableSelectLocked(lockSetting, number, query) {
  return !!lockSetting && hasScannedTable(number) && !entryOfQuery(query).generalTable
}
